import { Box, Text } from '@factorialco/deprecated-design-system'

import i18n from 'modules/core/lib/i18n'

interface Props {
  description?: string
}

export const EmptyState = ({ description }: Props) => (
  <Box justifyContent="center" alignItems="center" textAlign="center" gap="s16" maxWidth="s400">
    <Box gap="s4">
      <Text.Normal size="300" weight="semibold" color="grey1000">
        {i18n.t('procurement.purchase_orders.empty.title')}
      </Text.Normal>
      <Text.Normal size="200">{description}</Text.Normal>
    </Box>
  </Box>
)
